import React from 'react';
import { string, oneOfType, number } from 'prop-types';
import classnames from 'classnames';

export default function Discount({ className, value }) {
    const rootClassnames = classnames('prices__discount', className);

    return (
        <div className="prices__discount-wrapper">
            <span className={rootClassnames}>{`- ${value}%`}</span>
        </div>
    );
}

Discount.propTypes = {
    className: string,
    value: oneOfType([number, string]).isRequired,
};

Discount.defaultProps = {
    className: null,
};
